import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-arrow-circle-down",
  templateUrl: "./med-icon-arrow-circle-down.component.html",
})
export class MedIconArrowCircleDownComponent extends SvgMixinComponent {}
